import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const createCourseEnrolment = async (params) => {
  return await axios.post(`${baseURL}/course-enrolment`, params);
};

export const getCourseEnrolments = async (pageNo, pageSize, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  return await axios.get(`${baseURL}/course-enrolments`, { params });
};

export const updateCourseEnrolment = async (id, params) => {
  return await axios.put(`${baseURL}/course-enrolment/${id}`, params);
};

export const refundEnrolment = async (params) => {
  return await axios.post(`${baseURL}/refunds`, params);
};

export const getRefundEnrolments = async (
  paginationParams = {},
  otherParams = {}
) => {
  return await axios.get(`${baseURL}/refunds`, {
    params: {
      ...paginationParams,
      ...otherParams,
    },
  });
};

export const bulkUpdateCourseEnrolments = async (params) => {
  return await axios.patch(`${baseURL}/course-enrolments`, params);
};
